import * as types from '../../app/employer/redux/constants';

const initialState = {
   privileges: {},
   privilegesError: '',
};

export default function reducer(state = initialState, action) {
   switch (action.type) {
      case types.PRIVILEGES_FETCH_SUCCESS:
         return {
            ...state,
            privileges: action.payload.privileges,
            privilegesError: '',
         };
      default:
         return state;
   }
}
